function initDataArchCarousel() {
	const section = document.querySelector( '[data-vertical-carousel]' );

	if ( ! section ) return;

	const slides = Array.from( section.querySelectorAll( '.data-arch__slide' ) );
	const nav = section.querySelector( '.data-arch__nav' );

	if ( slides.length < 2 ) return;

	let activeIndex = -1;
	let ticking = false;

	section.style.setProperty( '--data-arch-slides', slides.length );

	if ( nav ) {
		nav.innerHTML = slides.map( () => '<span class="data-arch__dot"></span>' ).join( '' );
	}

	const dots = nav ? Array.from( nav.querySelectorAll( '.data-arch__dot' ) ) : [];

	function setActiveSlide( nextIndex ) {
		if ( nextIndex === activeIndex ) return;

		activeIndex = nextIndex;

		slides.forEach( ( slide, index ) => {
			slide.classList.toggle( 'is-active', index === activeIndex );
			slide.classList.toggle( 'is-before', index < activeIndex );
			slide.classList.toggle( 'is-after', index > activeIndex );
			slide.setAttribute( 'aria-hidden', index === activeIndex ? 'false' : 'true' );
		} );

		dots.forEach( ( dot, index ) => {
			dot.classList.toggle( 'is-active', index === activeIndex );
		} );
	}

	function update() {
		ticking = false;

		const rect = section.getBoundingClientRect();
		const scrollable = Math.max( 1, section.offsetHeight - window.innerHeight );
		const progress = Math.min( 1, Math.max( 0, -rect.top / scrollable ) );
		const nextIndex = Math.round( progress * ( slides.length - 1 ) );

		setActiveSlide( nextIndex );
	}

	function requestUpdate() {
		if ( ticking ) return;

		ticking = true;
		window.requestAnimationFrame( update );
	}

	setActiveSlide( 0 );
	update();

	window.addEventListener( 'scroll', requestUpdate, { passive: true } );
	window.addEventListener( 'resize', requestUpdate );
}

export default initDataArchCarousel;
